export default class RawMaterialBoxManagementColumnModel {
	static Column  = [
	  {
	    title: 'Raw material code',
	    align: 'left',
	    field: 'rawMaterialCode'
	  },
	  {
		  title: 'Raw material name',
		  align: 'left',
		  field: 'rawMaterialName'
	  },
	  {
	    title: 'Box Code',
	    align: 'left',
	    field: 'boxCode'
	  },
	  {
	    title: 'PO Number',
	    align: 'left',
	    field: 'poNumber'
	  },
	  {
	    title: 'Pallet',
	    align: 'left',
	    field: 'palletCode'
	  },
	  {
	    title: 'Position',
	    align: 'left',
	    field: 'position'
	  },	  	  	  
	]
}
